export const enum CurrencySetting {
  ALWAYS = "always",
  BY_COUNTRY = "by-country",
  CHOICE = "choice",
}
